import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

export default class dataCollectionManageService {
  // 查询
  static async getList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`api/std/DataAcquistionList?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 日、周、月对账单
  static async getTotleList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`api/std/DataAcquistionList?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取数据源接入数据量统计  数据源id,逗号分割
  static async findDataSourcePointCountUsingGET(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/home/findDataSourcePointCount/${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取首页已保存数据源配置Id
  static async findConfigDictionaryUsingGET() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(wizStandardInstance.get(`/home/findConfigDictionary`))
    return Callback(err, res)
  }
  // 保存首页已选择的数据源配置Id  数据源id,逗号分割
  static async saveConfigDictionaryUsingPOST(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(wizStandardInstance.post(`/home/saveConfigDictionary`, payload))
    return Callback(err, res)
  }
  // 获取所有数据源(页)
  static async getDataSourcePageUsingGET(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/source/config/getDataSourcePage`, payload)
    )
    return Callback(err, res)
  }
  // 获取协议数据（页）
  static async listPageUsingGET(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(wizStandardInstance.get(`/source/direct/listPage`, payload))
    return Callback(err, res)
  }
  // 获取测点总数
  static async findCountUsingGET() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(wizStandardInstance.get(`/measuringpoint/findCount`))
    return Callback(err, res)
  }
  // 获取指标总数
  static async findTargetCountUsingGET() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(wizStandardInstance.get(`/home/findTargetCount`))
    return Callback(err, res)
  }
  // 获取实趋势预测模型数量
  static async findTrendModelCountUsingGET() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(wizStandardInstance.get(`/home/findTrendModelCount`))
    return Callback(err, res)
  }
  // 获取实时数据总量
  static async findPointDataCountUsingGET() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(wizStandardInstance.get(`/home/findPointDataCount`))
    return Callback(err, res)
  }
  // 分页监控信息
  static async getMonitorInfoListPageUsingGET(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/home/getMonitorInfoList/${payload.pageNo}/${payload.pageSize}`)
    )
    return Callback(err, res)
  }
  // 获取数据源离线统计 时间 yyyy-MM-dd
  static async findDataSourceOfflineUsingGET(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/home/findDataSourceOffline/${payload.startTime}/${payload.endTime}`)
    )
    return Callback(err, res)
  }
  // 获取测点离线统计 时间 yyyy-MM-dd
  static async findPointOfflineUsingGET1(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/home/findPointOffline/${payload.startTime}/${payload.endTime}`)
    )
    return Callback(err, res)
  }
  // 获取数据源离线排行
  static async findDataSourceOrderUsingGET() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(wizStandardInstance.get(`/home/findDataSourceOrder`))
    return Callback(err, res)
  }
  // 获取测点离线排行
  static async findPointOfflineUsingGET() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(wizStandardInstance.get(`/home/findPointOrder`))
    return Callback(err, res)
  }
}
